(function () {
  if (window.__bdEducatorPreviewApiBound) return;
  window.__bdEducatorPreviewApiBound = true;

  var DEFAULT_ERROR =
    'Something went wrong starting your preview. Please try again or contact us.';

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
  }

  function toggleHidden(el, show) {
    if (!el) return;
    if (show) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  function readUtmParams() {
    var params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source') || 'baxterdog',
      utm_medium: params.get('utm_medium') || 'educators',
      utm_campaign: params.get('utm_campaign') || 'educator_48_hour_preview'
    };
  }

  function parseJsonResponse(response, text) {
    var contentType = (response.headers.get('content-type') || '').toLowerCase();
    if (!contentType.includes('application/json')) {
      return { ok: false, invalid: true };
    }
    if (!text) {
      return { ok: false, invalid: true };
    }
    try {
      return JSON.parse(text);
    } catch (error) {
      return { ok: false, invalid: true };
    }
  }

  function submitPreview(root, email) {
    var endpoint = (root.getAttribute('data-preview-endpoint') || '').trim();
    var previewType = (root.getAttribute('data-preview-type') || 'educator-k6-48-hour').trim();
    var source = (root.getAttribute('data-preview-source') || 'baxterdog-educators-page').trim();
    var utm = readUtmParams();

    if (!endpoint) {
      return Promise.reject(new Error('missing_endpoint'));
    }

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: String(email).trim(),
        source: source,
        preview_type: previewType,
        utm_source: utm.utm_source,
        utm_medium: utm.utm_medium,
        utm_campaign: utm.utm_campaign
      })
    }).then(function (response) {
      return response.text().then(function (text) {
        var payload = parseJsonResponse(response, text);

        if (payload.invalid || !response.ok || payload.ok === false) {
          if (window.console && window.console.warn) {
            window.console.warn('BaxterDog educator preview start failed', {
              status: response.status,
              invalid: payload.invalid || false,
              error: payload.error || null
            });
          }
          throw new Error('preview_failed');
        }

        return payload;
      });
    });
  }

  function showSuccess(root, payload) {
    var formPanel = root.querySelector('[data-educator-preview-form-panel]');
    var successPanel = root.querySelector('[data-educator-preview-form-success]');
    var redirectUrl =
      (payload && payload.redirect_url) ||
      (root.getAttribute('data-fallback-redirect') || '').trim();

    if (redirectUrl) {
      window.location.assign(redirectUrl);
      return;
    }

    toggleHidden(formPanel, false);
    toggleHidden(successPanel, true);
  }

  function setLoading(root, loading) {
    var submitBtn = root.querySelector('[data-educator-preview-submit]');
    if (!submitBtn) return;
    submitBtn.disabled = loading;
    if (loading) submitBtn.setAttribute('aria-busy', 'true');
    else submitBtn.removeAttribute('aria-busy');
  }

  function setValidationError(root, show) {
    var validationError = root.querySelector('[data-educator-preview-validation-error]');
    var submitError = root.querySelector('[data-educator-preview-submit-error]');
    var input = root.querySelector('[data-educator-preview-email]');
    toggleHidden(validationError, show);
    toggleHidden(submitError, false);
    if (input) {
      if (show) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
  }

  function setSubmitError(root, show) {
    var submitError = root.querySelector('[data-educator-preview-submit-error]');
    var validationError = root.querySelector('[data-educator-preview-validation-error]');
    toggleHidden(submitError, show);
    if (show) toggleHidden(validationError, false);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('[data-educator-preview-form-inner]')) return;

    event.preventDefault();

    var root = form.closest('[data-educator-preview-form]');
    if (!root) return;

    var input = root.querySelector('[data-educator-preview-email]');
    var email = input ? input.value : '';

    if (!isValidEmail(email)) {
      setValidationError(root, true);
      if (input) input.focus();
      return;
    }

    setValidationError(root, false);
    setSubmitError(root, false);
    setLoading(root, true);

    submitPreview(root, email)
      .then(function (payload) {
        showSuccess(root, payload);
        form.reset();
      })
      .catch(function () {
        setSubmitError(root, true);
      })
      .finally(function () {
        setLoading(root, false);
      });
  });

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.matches('[data-educator-preview-email]')) return;
    var root = input.closest('[data-educator-preview-form]');
    if (!root) return;
    var validationError = root.querySelector('[data-educator-preview-validation-error]');
    if (validationError && !validationError.hasAttribute('hidden')) {
      setValidationError(root, !isValidEmail(input.value));
    }
  });
})();
